export default "__VITE_ASSET__C50XCSg1__"